import { logos, logoComunidad } from '../../../../assets';
import Login from '../../hooks/Login';
import Header from './Header';
import Fields from './Fields';
import Actions from './Actions';

const LoginForm = ({ onLogin, onForgotPassword, onCreateAccount, message }) => {
  const vm = Login({ onLogin, message });

  return (
    <div className="min-h-[100dvh] w-full overflow-hidden flex items-center justify-center px-3 py-2 sm:px-5 lg:px-6 lg:py-1">
      <div className="w-full max-w-[14.5rem] sm:max-w-[15rem] lg:max-w-[14.75rem] xl:max-w-[15rem]">
        <Header logoComunidad={logoComunidad} />

        <div className="bg-white shadow-lg px-4 py-3 sm:px-4 sm:py-3 lg:px-4 lg:py-3">
          <h2 className="text-base text-center text-gray-800 mb-2 sm:text-lg lg:mb-2 lg:text-lg">
            Iniciar sesi&oacute;n
          </h2>
          <form onSubmit={vm.handleSubmit} className="space-y-1.5 lg:space-y-2">
            <Fields
              email={vm.email}
              setEmail={vm.setEmail}
              password={vm.password}
              setPassword={vm.setPassword}
              loading={vm.loading}
            />
            <Actions
              loading={vm.loading}
              onForgotPassword={onForgotPassword}
              onCreateAccount={onCreateAccount}
            />
          </form>
        </div>

        <div className="flex justify-center pt-2 lg:pt-1.5">
          <img src={logos} alt="Esri Colombia Ecuador Panama" className="w-20 h-auto opacity-95 sm:w-24 lg:w-24" />
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
